export const getProfileAvatarUrl = (profile, fallback = "") => {
  const avatar = profile?.avatar;
  const avatarValue = typeof avatar === "string"
    ? avatar
    : avatar?.url || avatar?.secure_url;

  return String(
    avatarValue || profile?.avatarUrl || profile?.profileImage || fallback || ""
  ).trim();
};